// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"312":"c2183e02986920ea","639":"855337ded3b2fa32"}[chunkId] + ".js";
};